export const MuiDrawer = {
  styleOverrides: {
    paper: {
      backgroundColor: "#42413e",
      backgroundImage: "none",
    },
  },
};
